import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const templeSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    editLoading: false,
    createLoading: false,
    getLoading: false,
    list: [],
    data: {},
    vehicleList: [],
    isStatusChange: false,
    trendingTemples:[],
    templeReport:[]
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    createLoading: (state, action) => {
      state.createLoading = action.payload;
    },
    getLoading: (state, action) => {
      state.getLoading = action.payload;
    },
    editLoading: (state, action) => {
      state.editLoading = action.payload;
    },
    templeListSuccess: (state, action) => {
      state.list = action.payload.data;
    },
    createTemplateSuccess: (state, action) => {
      state.isStatusChange = true;
    },
    oneTempleData: (state, action) => {
      state.data = action.payload.temple;
    },
    getVehicleLists: (state, action) => {
      state.vehicleList = action.payload.vehicle_types;
    },
    clearStateChange: (state, action) => {
      state.isStatusChange = false;
    },
    trendingTemples:(state, action) => {
      state.trendingTemples = action.payload;
    },
    templeReport:(state, action) => {
      state.templeReport = action.payload.data;
    }
  }
});

export const { templeListSuccess, loading, createLoading, getLoading, editLoading, createTemplateSuccess, clearStateChange, templeReport, oneTempleData, getVehicleLists,trendingTemples } = templeSlice.actions;

export const getTempleList = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_all_temples`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(templeListSuccess(data));
      dispatch(loading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      dispatch(loading(false));
      errorHandling(error);
    }
  };


export const createTemple = (formData, navigate) =>
  async (dispatch) => {
    try {
      dispatch(createLoading(true));
      dispatch(clearStateChange());
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/store_temple`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createTemplateSuccess());
      toast.success("Temple Created Successfully");
      navigate(-1);
      dispatch(createLoading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      dispatch(createLoading(false));
      errorHandling(error);
    }
  };

export const getTempleData = (id) =>
  async (dispatch) => {
    try {
      dispatch(getLoading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/edit_temple/${id}`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(oneTempleData(data));
      dispatch(getLoading(false));
    } catch (error) {
      toast.error(error?.response?.data.error);
      console.log("error", error);
      dispatch(getLoading(false));
      errorHandling(error);
    }
  };

export const editTemple = (id, editableData, navigate) =>
  async (dispatch) => {
    try {
      dispatch(editLoading(true));
      dispatch(clearStateChange());
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_temple/${id}`;
      const { data } = await axios.post(url, editableData, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createTemplateSuccess());
      toast("Temple Updated Successfully");
      navigate(-1);
      dispatch(editLoading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      dispatch(editLoading(false));
      errorHandling(error);
    }
  };

export const deleteTempleImage = (deletableImageData, existingImages, setExistingImages, setDeleteModal) =>
  async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/remove_temple_images`;
      const { data } = await axios.post(url, deletableImageData, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      toast("Image Deleted Successfully");
      const updatedImages = [...existingImages];
      updatedImages.splice(deletableImageData.image_index, 1);
      setExistingImages(updatedImages);
      setDeleteModal(false);
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      errorHandling(error);
    }
  };

export const deleteTemple = (id, setDeletableId, setDeleteModal) =>
  async (dispatch) => {
    try {
      dispatch(clearStateChange());
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/destroy_temple/${id}`;
      const { data } = await axios.post(url, {}, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(createTemplateSuccess());
      toast("Temple Deleted Successfully");
      setDeletableId(null);
      setDeleteModal(false);
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      errorHandling(error);
    }
  };

export const getVehicleList = () =>
  async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_vehicle_type`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(getVehicleLists(data));
    } catch (error) {
      toast.error(error?.response?.data?.error);
      console.log("error", error);
      errorHandling(error);
    }
  };

  export const getTrendingTempleList = () =>
    async (dispatch) => {
      try {
        dispatch(loading(true));
        const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_trending_temples_list`;
        const { data } = await axios.get(url, {
          headers: {
            Authorization: localStorage.getItem('token')
          }
        });
        dispatch(trendingTemples(data?.temples));
        dispatch(loading(false));
      } catch (error) {
        toast.error(error.response.data.error);
        console.log("error", error);
        dispatch(loading(false));
        errorHandling(error);
      }
};

export const updateTrendingTempleList = (body) =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/trending_temples`;
      const { data } = await axios.post(url,body,{
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(loading(false));
    } catch (error) {
      toast.error(error.response.data.error);
      console.log("error", error);
      dispatch(loading(false));
      errorHandling(error);
    }
};

export const getTempleReport = () =>
  async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/temple_report`;
      const { data } = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      });
      dispatch(templeReport(data));
      dispatch(loading(false));
    } catch (error) {
      console.log("error", error);
    }
  };
export default templeSlice.reducer;